import Button, { type ButtonProps } from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { ArchiveBox, DirectSend } from 'iconsax-react';
import type { FC, ReactElement } from 'react';

interface ArchiveButtonProps extends ButtonProps {
  isLoading?: boolean;
  isArchived: boolean;
  canArchive?: boolean;
}

export const ArchiveButton: FC<ArchiveButtonProps> = ({
  isArchived,
  isLoading = false,
  canArchive = true,
  color = 'inherit',
  variant = 'text',
  startIcon,
  disabled,
  ...props
}) => {
  const Icon: ReactElement = isArchived ? <DirectSend /> : <ArchiveBox />;

  const text: string = isArchived ? 'Restore' : 'Archive';

  if (!canArchive) {
    return null;
  }

  return (
    <Button
      disabled={isLoading || disabled}
      startIcon={!isLoading && (startIcon ?? Icon)}
      variant={variant}
      color={color}
      {...props}
    >
      {isLoading ? <CircularProgress size={20} color='inherit' /> : text}
    </Button>
  );
};
